/* eslint-disable testing-library/render-result-naming-convention */
/* Copyright (c) 2020-present CloudIO Inc */
import { observable } from '@legendapp/state';
import { useObserve } from '@legendapp/state/react';
import useMounted from 'hooks/useMounted';
import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import './maskpage.css';
import { useStylesLoader } from 'layout/Sidebar/panels/SettingsView/settings/MaskLoaderSettings';
import { appLoadingAnimAtom } from 'utils/state';
import { useAppID } from 'designer/atoms';
import { useStateXAtomValue } from '@cloudio-saas/statex';

const useStyles = makeStyles(() => ({
  loader: {
    position: 'absolute',
    top: 'calc(50% - 30px)',
    left: 'calc(50% - 100px)',
    alignItems: 'center',
    minWidth: '200px',
    minHeight: '60px',
    display: 'flex',
    height: 'auto',
    width: 'auto',
    justifyContent: 'center',
    color: '#444',
    zIndex: 99999,
  },
  loaderMaskPage: {
    width: '100%',
    height: '100%',
    top: 'auto',
    left: 'auto',
    backgroundColor: 'rgba(245, 247, 250, 0.25)',
  },
}));

export const maskPageSignal = observable({ postCount: 0, queryCount: 0 });

function MaskPage(): React.ReactElement | null {
  const [loading, setLoading] = React.useState(false);
  const mounted = useMounted(false);
  const appUid = useAppID();
  const classes_loader = useStylesLoader();

  useObserve(() => {
    const _loading = maskPageSignal.postCount.get() > 0;
    const __loading = maskPageSignal.queryCount.get() > 0;
    setTimeout(() => {
      if (mounted.current) {
        setLoading(_loading || __loading);
      }
    }, 1);
  });

  const classes = useStyles();
  const masking = clsx(classes.loader, {
    [classes.loaderMaskPage]: loading,
  });
  const animationOption = useStateXAtomValue(appLoadingAnimAtom, {
    params: { appUid },
  });
  return loading ? (
    <div id="loading-animation" className={masking}>
      <div style={{ height: '60px', width: '60px' }}>
        {animationOption !== 'dotted-spinner' ? (
          <div
            className={
              animationOption === 'spinner'
                ? classes_loader.loaderSpinner
                : animationOption === 'dots'
                ? classes_loader.loaderDots
                : animationOption === 'bars'
                ? classes_loader.loaderBars
                : ''
            }
          >
            {(animationOption === 'dots' || animationOption === 'bars') && (
              <div></div>
            )}
          </div>
        ) : (
          <div id="loader">
            <div className="loader-item a"></div>
            <div className="loader-item b"></div>
            <div className="loader-item c"></div>
            <div className="loader-item d"></div>
            <div className="loader-item e"></div>
            <div className="loader-item f"></div>
            <div className="loader-item g"></div>
            <div className="loader-item h"></div>
          </div>
        )}
      </div>
    </div>
  ) : null;
}

export default memo(MaskPage);
